import { CarouselApi } from "@/components/ui/carousel";
import { useMobile } from "@/lib/hooks/use-mobile";
import { useEffect, useState } from "react";

export const useCarouselDrag = (api: CarouselApi) => { 
  const [isDragging, setIsDragging] = useState(false);
  const { isMobile } = useMobile();

  useEffect(() => {
    if (!api) {
      return;
    }
    if (!isMobile) {
      return;
    }

    const onPointerDown = () => setIsDragging(true);
    const onPointerUp = () => setIsDragging(false);

    api.on("pointerDown", onPointerDown);
    api.on("pointerUp", onPointerUp);

    return () => {
      api.off("pointerDown", onPointerDown);
      api.off("pointerUp", onPointerUp);
    };
  }, [api, isMobile]);

  return isDragging;
}